const $bar = $('#cookie-bar');
const $btnAccept = $('.js-accept-cookie');
const $btnClose = $('.js-close-bar');

const createCookie = (cookieName, cookieValue, daysToExpire) => {
	const date = new Date();

	date.setTime(date.getTime() + (daysToExpire*24*60*60*1000));

	document.cookie = `${cookieName}=${cookieValue}; expires=${date.toGMTString()}`;
}

const accessCookie = (cookieName) => {
	const name = `${cookieName}=`;
	const allCookieArray = document.cookie.split(';');

	for(let i = 0; i < allCookieArray.length; i++) {
		const temp = allCookieArray[i].trim();

		if (temp.indexOf(name)==0) {
			return temp.substring(name.length,temp.length);
		}
	}

	return "";
}

const checkCookie = () => {
	$bar.toggleClass('active', accessCookie('Novotel') == '')
}

const acceptCookies = () => {
	createCookie('Novotel','Novotel cookies',30);

	closeCookieBar();
}

const closeCookieBar = () => {
	$bar.removeClass('active');
}

export default function cookiesUI() {
	checkCookie();

	$btnAccept.on('click', acceptCookies);

	$btnClose.on('click', closeCookieBar);
}
